import { Link } from "react-router-dom";
import { Van, HeartStraight, ArrowRight } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";

const DEFAULT_MSG = "CareDeserved Is Hiring! NEMT Drivers + ODP / Human Services Professionals — Full-Time, Part-Time & PRN Opportunities Available. View Open Positions & Apply Today";

export function RecruitTicker() {
  const content = useSite();
  if (content.recruit_ticker_enabled === false) return null;
  const msg = (content.recruit_ticker_text || DEFAULT_MSG).trim();
  if (!msg) return null;

  const onClick = () => {
    try { sessionStorage.setItem("cd_ticker_click", "1"); } catch (e) { /* ignore */ }
    api.post("/track/ticker-click").catch(() => {});
  };

  const Item = () => (
    <span className="mx-8 inline-flex items-center gap-2.5 text-sm font-semibold text-white sm:text-[15px]" aria-hidden="true">
      <Van size={20} weight="fill" className="shrink-0 text-brand-teal2" />
      <HeartStraight size={16} weight="fill" className="shrink-0 text-white/90" />
      {msg}
      <ArrowRight size={16} weight="bold" className="shrink-0 text-brand-teal2" />
    </span>
  );

  return (
    <Link
      to="/careers"
      onClick={onClick}
      data-testid="recruit-ticker"
      aria-label={`${msg}. View current job openings and apply.`}
      className="marquee group block bg-gradient-to-r from-brand-blue via-brand-purple to-brand-teal focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal2 focus-visible:ring-inset"
    >
      <div className="relative flex overflow-hidden py-2.5">
        {/* Static, accessible copy for reduced-motion + screen readers */}
        <span className="sr-only">{msg}. View current job openings and apply today.</span>
        <div className="marquee-track flex whitespace-nowrap will-change-transform" aria-hidden="true">
          {Array.from({ length: 6 }).map((_, i) => <Item key={i} />)}
        </div>
        <div className="marquee-track flex whitespace-nowrap will-change-transform" aria-hidden="true">
          {Array.from({ length: 6 }).map((_, i) => <Item key={`b${i}`} />)}
        </div>
      </div>
    </Link>
  );
}
